import { useEffect, useMemo, useState } from 'react';
import { useKeepAliveActive } from './keepAliveActive';
import { PAGE_READ_TIMEOUT_MS } from '@/utils/readRequestDeadline';

/** Bound only an empty initial-load UI, never a save/export or a populated form. */
export function useLoadingDeadline(
  pending = true,
  resetKey = typeof window === 'undefined'
    ? ''
    : window.location.pathname + window.location.search,
): boolean {
  const active = useKeepAliveActive();
  // An expired previous route/attempt must not flash an error on the next one.
  const attempt = useMemo(() => ({}), [active, pending, resetKey]);
  const [expiredAttempt, setExpiredAttempt] = useState<object>();
  useEffect(() => {
    if (!pending || !active) return undefined;
    const timer = setTimeout(
      () => setExpiredAttempt(attempt),
      PAGE_READ_TIMEOUT_MS,
    );
    return () => clearTimeout(timer);
  }, [pending, active, attempt]);
  return pending && active && expiredAttempt === attempt;
}
